import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CajasService extends ApiService {
    entityType = EntityType.CAJA;
    url = 'api/dimensiones-cajas/';
}
